export const navigationUrl = 'https://workspace.teaminterval.net';
export const studentUrl = 'https://student.teaminterval.in/';
const API_URL = process.env.REACT_APP_API_URL;
export const uploadedFileUrl = `${API_URL}uploads`;
export const uploadedFileUrlContabo = `${process.env.REACT_APP_CONTABO_UPLOADS_BASE_URL}`;

export const chatPhotoUrl = 'https://workspace.teaminterval.net/assets/employee/photo/passport_size';
